// import media from './media';

export const theme = {
  colors: {
    black: '#000000',
    white: `#ffffff`,
    bgColor: '#F5F4EF',
    headlineOne: '#7A9177',
    par: '#50514F',
    // par: '#A4A39E',
  },
  fontSize: {
    xl: `40px`,
    l: `20px`,
    m: `16px`,
    s: `12px`,
  },

  media: {
    mobile: `(min-width: 320px)`,
    tablet: `(min-width: 768px)`,
    laptop: `(min-width: 1024px)`,
  },
};

// Media Queris jak uzywac

//  @media ${({ theme }) => theme.media.tablet} {
//   font-size: ${({ theme }) => theme.fontSize.xl};
// }
